/**
 * Zone.js configuration flags
 *
 * IMPORTANTE: Este archivo debe importarse ANTES de zone.js
 *
 * Objetivo: que los eventos de alta frecuencia que dispara Mapbox al navegar/
 * arrastrar el mapa (mousemove/pointermove/touchmove/wheel) NO sean parcheados
 * por Zone.js. Si Zone los envuelve, cada evento dispara un ciclo de change
 * detection de toda la app → al arrastrar el mapa el CPU sube al 100%.
 *
 * Mecanismo correcto: `__zone_symbol__UNPATCHED_EVENTS` (lista de eventos que
 * Zone deja correr FUERA de la zona). Es el modo soportado/documentado.
 * (Antes se usaba `__Zone_disable_<evento>`, que NO es un flag válido para
 * eventos → era inefectivo y los eventos seguían disparando CD.)
 *
 * Los handlers de estos eventos (Mapbox) corren fuera de zona → no hay CD.
 * Los clicks NO se incluyen: abren popups y usan ngZone.run() explícito cuando
 * necesitan actualizar UI.
 *
 * Documentación: https://github.com/angular/angular/blob/main/packages/zone.js/MODULE.md
 */

(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  // Mouse de alta frecuencia (drag/hover del mapa)
  'mousemove',
  'mouseenter',
  'mouseleave',
  'mouseover',
  'mouseout',
  'wheel',
  'scroll',
  // Pointer events (Mapbox/Chrome modernos los usan para drag)
  'pointermove',
  'pointerover',
  'pointerout',
  'pointerenter',
  'pointerleave',
  // Touch (drag en táctil)
  'touchmove',
];
